import { useEffect } from "react";
import splashConfig from "../../config/splashConfig";

/**
 * Full-screen overlay that sits on top of the entire site.
 *
 * The rest of the app still mounts and renders behind this (so
 * "the existing website in the background"), but this overlay
 * blocks all clicks/scrolling/keyboard interaction with it, and
 * visually hides it behind a dimmed, blurred backdrop — leaving
 * only the announcement image visible.
 *
 * Turn this on/off via client/src/config/splashConfig.js.
 */
function SplashScreen() {
  useEffect(() => {
    // Prevent the page behind the overlay from scrolling
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <div
      className="splash-screen"
      role="dialog"
      aria-modal="true"
      aria-label={splashConfig.imageAlt}
    >
      <div className="splash-screen__backdrop" />
      <img
        className="splash-screen__image"
        src={splashConfig.imageSrc}
        alt={splashConfig.imageAlt}
      />
    </div>
  );
}

export default SplashScreen;
